import React from 'react';

import { SHELTER_QUALITY_PATH } from 'dpl/shared/constants/urls';
import SmartImage from 'dpl/components/SmartImage';
import Icon from 'dpl/common/components/Icon';

import pawAndHandSvg from 'dpl/assets/paw_and_hand.svg';

export default function Badge() {
  return (
    <div className="ShelterBadge ph6 br1 ba b--stone-700 bw1">
      <div className="row items-center">
        <div className="col-xl-8">
          <div className="pv5">
            <p className="mb2 stone-700 f4 f6-xl fw-medium">New to Good Dog?</p>
            <p className="mb4 f2">
              Good Dog is on a mission to stop inhumane and deceptive practices
              by educating prospective dog owners and helping them connect
              directly with our community of vetted, responsible breeders,
              shelters, and rescues.
            </p>
            <a
              className="flex items-center link--primary fw-medium"
              href={SHELTER_QUALITY_PATH}
              rel="noopener noreferrer"
              target="_blank"
            >
              <span>What&apos;s a Good Shelter or Rescue?</span>
              <Icon name="fat-arrow-right" />
            </a>
          </div>
        </div>
        <div className="col-xl-4 relative overflow-y-hidden tc">
          <SmartImage
            alt="paw and hand"
            className="d-none d-xl-block h-100 center"
            src={pawAndHandSvg}
          />
        </div>
      </div>
    </div>
  );
}
